import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AccordionItem } from './AccordionItem';
import './accordion.scss';

function Accordion({
	className,
	content = [],
	faqSchema,
	preserve = false,
	type,
	openItemIndex,
	onToggleItem,
}) {
	const isControlled = typeof onToggleItem === 'function';

	const handleToggleItem = useCallback(
		(index) => {
			if (isControlled) {
				onToggleItem(index);
			}
		},
		[isControlled, onToggleItem]
	);

	return (
		<div className={classNames('accordion', className)}>
			{content.map(({ question, answer, link }, index) => (
				<AccordionItem
					key={question || index}
					question={question}
					answer={answer}
					link={link}
					preserve={preserve}
					type={type}
					expanded={isControlled ? openItemIndex === index : undefined}
					onToggle={isControlled ? handleToggleItem : undefined}
					toggleIndex={index}
				/>
			))}

			{faqSchema && (
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: faqSchema }}
				/>
			)}
		</div>
	);
}

Accordion.propTypes = {
	className: PropTypes.string,
	content: PropTypes.arrayOf(
		PropTypes.shape({
			question: PropTypes.string,
			answer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
			link: PropTypes.string,
		})
	),
	faqSchema: PropTypes.string,
	preserve: PropTypes.bool,
	type: PropTypes.string,
	openItemIndex: PropTypes.number,
	onToggleItem: PropTypes.func,
};

export default React.memo(Accordion);